export default
{
  page: ['Página', 'Page', 'Página'],
  of: ['de', 'of', 'de'],
  notConfigured: ['Seu guia de estilo virtual ainda não foi configurado', 'Your moodboard has not yet been configured', 'Su moodboard todavía no ha sido configurado'],
  notConfiguredCategory: ['A categoria ainda não foi configurada', 'The category has not yet been configured', 'La categoría todavía no ha sido configurada']
}



// WEBPACK FOOTER //
// ./src/constants/Moodboard.js